const HeadData = [
   {
      id: 0,
      index: 0,
      desc: "commodo pariatur exercitation fugiat sit culpa sint deserunt officia pariatur commodo incididunt tempor pariatur",
      subtitle: "Subtítulo de encabezado",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      images: {desk: "Harvey.jpg", mobile: "Cherry.jpg"},
      type: "esenciales",
   },
   {
      id: 1,
      index: 1,
      desc: "nisi non minim officia veniam veniam enim minim aute do nisi excepteur",
      subtitle: "Subtítulo de encabezado",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      images: {desk: "Mays.jpg", mobile: "Bond.jpg"},
      type: "prime",
   },
   {
      id: 2,
      index: 2,
      desc:
         "excepteur anim nulla deserunt cillum cillum proident est elit proident dolore officia sint amet cupidatat proident labore enim aliquip ut duis minim ad aute in occaecat",
      subtitle: "Subtítulo de encabezado",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      images: {desk: "Burris.jpg", mobile: "Skinner.jpg"},
      type: "home",
   },
   {
      id: 3,
      index: 3,
      desc:
         "cupidatat ut nulla ipsum aliqua adipisicing adipisicing amet exercitation voluptate ea velit amet ut ad do cillum aliquip dolor occaecat aliqua tempor irure consectetur ut exercitation minim esse mollit duis labore eu adipisicing anim",
      subtitle: "Subtítulo de encabezado",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      images: {desk: "Geneva.jpg", mobile: "Mcpherson.jpg"},
      type: "academy",
   },
   {
      id: 4,
      index: 4,
      desc:
         "ullamco cupidatat aliqua laboris ex sunt veniam eu id magna quis eiusmod irure aute mollit exercitation Lorem aute labore elit ipsum commodo",
      subtitle: "Subtítulo de encabezado",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      images: {desk: "Walsh.jpg", mobile: "Sandoval.jpg"},
      type: "facilitadores",
   },
   {
      id: 5,
      index: 5,
      desc:
         "officia eiusmod magna laborum excepteur consequat ea cupidatat aliquip ad labore mollit commodo reprehenderit sit non esse eiusmod nostrud laboris minim dolor aliquip reprehenderit officia velit cillum ex reprehenderit sunt deserunt reprehenderit ad",
      subtitle: "Subtítulo de encabezado",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      images: {desk: "Mccarthy.jpg", mobile: "Hinton.jpg"},
      type: "enterprise",
   },
   {
      id: 6,
      index: 6,
      desc:
         "consequat incididunt tempor reprehenderit aliqua sint excepteur esse deserunt sint amet sit in fugiat Lorem reprehenderit eiusmod cillum ipsum veniam dolor nisi ex minim voluptate anim magna magna reprehenderit ex adipisicing",
      subtitle: "Subtítulo de encabezado",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      images: {desk: "Eliza.jpg", mobile: "Chaney.jpg"},
      video: {desk: "Eliza.mp4", mobile: "Chaney.mp4"},
      type: "academy",
   },
   {
      id: 7,
      index: 7,
      desc:
         "labore non et pariatur ex eiusmod magna nisi eu ullamco cillum dolor officia sint laborum proident ullamco fugiat irure fugiat sit proident ea incididunt dolore non cillum elit excepteur sit",
      subtitle: "Subtítulo de encabezado",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      images: {desk: "Hoover.jpg", mobile: "Bailey.jpg"},
      type: "home",
   },
   {
      id: 8,
      index: 8,
      desc:
         "dolore dolor reprehenderit cillum exercitation fugiat ullamco elit eu esse commodo excepteur amet Lorem do duis occaecat sit voluptate officia sint enim aliquip tempor culpa adipisicing officia do",
      subtitle: "Subtítulo de encabezado",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      images: {desk: "Desiree.jpg", mobile: "Cruz.jpg"},
      type: "emblem",
   },
   {
      id: 9,
      index: 9,
      desc:
         "magna enim duis ut Lorem amet nulla reprehenderit culpa ullamco ex duis ut laboris nisi magna eu nulla Lorem consequat Lorem ex ea id Lorem mollit ex non",
      subtitle: "Subtítulo de encabezado",
      link: "https://reacttraining.com/react-router/web/api/Redirect",
      images: {desk: "Larsen.jpg", mobile: "Little.jpg"},
      type: "home",
   },
];

export default HeadData;
